module.exports = __webpack_public_path__ + "img/arrow-down-triangle-square.e6ce31d2.svg";